import { render, staticRenderFns } from "./TipoTarefaList.vue?vue&type=template&id=34fc64f0"
import script from "./TipoTarefaList.vue?vue&type=script&lang=js"
export * from "./TipoTarefaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports